import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './create-room.css';

function CreateRoom() {
  const [roomName, setRoomName] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/rooms/create`,
        { name: roomName, password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const encodedCreatorId = btoa(response.data.creatorId + '_' + response.data.roomId);
      localStorage.setItem(`room_${response.data.roomId}_creator`, encodedCreatorId);
      localStorage.setItem(`room_${response.data.roomId}_verified`, 'true');
      navigate(`/room/${response.data.roomId}`);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/login');
      } else {
        alert('Có lỗi xảy ra khi tạo phòng. Vui lòng thử lại!');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="create-room-container">
      <div className="create-room-card">
        <div className="create-room-header">
          <h2>Tạo phòng Give Away mới</h2>
          <p>Tạo không gian quay thưởng cho cộng đồng của bạn</p>
        </div>
        
        <div className="create-room-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Tên phòng</label>
              <input
                type="text"
                className="form-control"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
                placeholder="Nhập tên phòng..."
                required
              />
              <small className="form-text">
                Tên phòng sẽ hiển thị cho tất cả người tham gia
              </small>
            </div>

            <div className="form-group">
              <label className="form-label">Mật khẩu phòng</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu phòng..."
                required
              />
              <small className="form-text">
                Mật khẩu dùng để bảo vệ phòng của bạn
              </small>
            </div>

            <button 
              type="submit" 
              className="create-room-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Đang tạo phòng...
                </>
              ) : (
                <>
                  <i className="fas fa-plus-circle"></i>
                  Tạo phòng ngay
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateRoom; 